// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__HAZfw","checkbox-wrapper":"Variant_checkbox-wrapper__LeooZ","checkbox":"Variant_checkbox__GsNVV","variant-body":"Variant_variant-body__gzWwP"};